import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./page/Dashboard";
import ClientLogin from "./page/ClientLogin";
import BookingForm from "./component/BookingForm";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ClientLogin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/bookingForm" element={<BookingForm />} />
      </Routes>
    </Router>
  );
}

export default App;
